import React from 'react';
import { NavbarItemMarkup } from './NavbarItemEnum';
import { is } from '../../../services';
import { hashClass } from '../../../helpers';
import clsx from 'clsx';
import { useTrilogyContext } from '../../../context';
/**
 * Navbar Item Component
 * @param children {ReactNode} Children
 * @param className {string} Additionnal css classes
 * @param id {string} Custom id
 * @param markup {NavbarItemMarkup} Available : (DIV|A|SPAN|P) : Default : DIV
 * @param hoverable {boolean} Hoverable item
 * @param hiddenMobile {boolean} Hide on mobile
 * @param hiddenTablet {boolean} Hide on tablet
 * @param hiddenDesktop {boolean} Hide on desktop
 * @param alternate {boolean} Use it for connect button
 * @param megaDropdown {boolean} If have mega dropdown
 * @param active {boolean} If active
 */
const NavbarItem = ({ children, id, className, megaDropdown, hoverable, markup, hiddenMobile, hiddenTablet, hiddenDesktop, alternate, active, testId, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('navbar-item', megaDropdown && is('megadropdown-parent'), hoverable && is('hoverable'), hiddenMobile && is('hidden-mobile'), hiddenTablet && is('hidden-tablet'), hiddenDesktop && is('hidden-desktop'), alternate && is('alternate'), active && is('active'), className));
    const isCorrectMarkup = (stringMarkup) => {
        if (stringMarkup in NavbarItemMarkup || Object.values(NavbarItemMarkup).includes(stringMarkup))
            return true;
    };
    const Tag = markup && isCorrectMarkup(markup) ? markup : 'div';
    return (React.createElement(Tag, { id: id, "data-testid": testId, className: classes, ...others }, children));
};
export default NavbarItem;
//# sourceMappingURL=NavbarItem.js.map